import React from "react";
import { LOGOS, BRAND } from "@/config/site";

// The Group mark is a circular badge on a near-white background, so a white
// circular chip renders seamlessly on both dark and light surfaces.
export function GroupLogo({ className = "h-12", withText = true, textClass = "text-white", subClass = "text-orange-accent" }) {
  return (
    <span className="inline-flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGOS.group}
        alt="Atmasamman Group logo"
        className={`${className} aspect-square w-auto shrink-0 rounded-full bg-white object-contain p-[2px] shadow-sm ring-1 ring-black/10`}
      />
      {withText && (
        <span className="flex flex-col leading-tight">
          <span className={`font-display text-lg font-extrabold tracking-tight ${textClass}`}>Atmasamman</span>
          <span className={`font-mono text-[10px] font-semibold uppercase tracking-[0.32em] ${subClass}`}>Group</span>
        </span>
      )}
    </span>
  );
}

export const BRAND_NAME = BRAND.name;
